import {LocalDate} from "js-joda";
import * as DateUtil from '../utils/DateUtil'
import * as AppDimensions from '../constants/AppDimensions';
import {grey900, grey600} from "material-ui/styles/colors";

export default {
  availabilityState : {
    availability : {
      properties: []
    },
    properties : {

    },
    criteria : {
      startDate : DateUtil.localDateToString(LocalDate.now(), 'yyyy-MM-dd'),
      endDate : DateUtil.localDateToString(LocalDate.now().plusDays(AppDimensions.noOfNights), 'yyyy-MM-dd'),
      roomBreakdown: [
        {
          adults: 2,
          children: []
        }
      ],
      currency: "ZAR",
      properties: [
        {
          code: "UNKNOWN",
          id: 9999999
        }
      ]
    },
    showState: false,
    showRate: true,
    bookable: true,
    displayNoOfNights: AppDimensions.noOfNights,
    muiTheme : {
      palette: {
        primary1Color: grey900,
        primary2Color: grey600,
        pickerHeaderColor: grey900,
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/store/initialState.js